import { ProductionOrderCreatePage } from "@/features/production/pages/ProductionOrderCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/production/create")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["production.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ProductionOrderCreatePage,
});
